// Organizational structure for Loom
export const ORG_STRUCTURE = {
  "Technology": [
    "VP of Technology",
    "Business Intelligence - Manager",
    "Business Intelligence - Data Analyst",
    "Product - Product Manager",
    "Product - Product Owner",
    "Information Technology - Supervisor",
    "Information Technology - Support",
    "Integration - VP of Integration",
    "Integration - Integration Specialist",
    "Software Engineering - Software Engineering Manager",
    "Software Engineering - Software Engineer"
  ],
  "Care": [
    "VP of Care",
    "Director of Care",
    "Business Manager",
    "Manager of Care",
    "Manager of Care Operations",
    "Team Lead",
    "Care Coordinator - Internal",
    "Care Coordinator - SaaS"
  ],
  "Client Success": [
    "Director of Client Success",
    "Client Success Manager"
  ],
  "Marketing": [
    "Marketing Manager",
    "Marketing Generalist"
  ],
  "Sales": [
    "Director of Sales",
    "Sales Manager"
  ],
  "Financial": [
    "Director of Finance",
    "Financial Analyst"
  ],
  "Enrollment": [
    "Enrollment Manager",
    "Enrollment Lead",
    "Enrollment Specialist"
  ],
  "Human Resources": [
    "Director of People",
    "HR Generalist",
    "Talent Acquisition"
  ]
};

// Get all departments
export const getDepartments = () => Object.keys(ORG_STRUCTURE);

// Get roles for a specific department
export const getRolesForDepartment = (department) => ORG_STRUCTURE[department] || [];

// Get all roles (flat list)
export const getAllRoles = () => {
  return Object.values(ORG_STRUCTURE).flat();
};
